module.exports = __webpack_public_path__ + "static/for_whom_undertaking-4b0a03981c66351cb183d13cc61b54f8.jpg";